import { action } from 'satcheljs';

export interface SET_SHOW_MESSAGE_PREVIEWActionMessage {
    showPreviewTextInListView: boolean;
}
export const setShowMessagePreview: (
    showPreviewTextInListView: boolean
) => SET_SHOW_MESSAGE_PREVIEWActionMessage = action(
    'SET_SHOW_MESSAGE_PREVIEW',
    (showPreviewTextInListView: boolean): SET_SHOW_MESSAGE_PREVIEWActionMessage => ({
        showPreviewTextInListView,
    })
);
